import { OrderRegularMedicationsProvider } from '../OrderRegularMedicationsContext';

export const CreateOrderWrapper = () => (
  <OrderRegularMedicationsProvider
    handleClose={() => {}}
    open
    openSuccessOrderDialog={() => {}}
    setSuccessOrderDialogExpiredPrescriptions={() => {}}
    isCreateOrder={true}
  />
);
